import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSpark = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-spark';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M10.489 2.103a.8.8 0 0 0-.289.237c-.055.089-.322 1.168-.795 3.217-.391 1.696-.72 3.092-.731 3.102-.011.011-1.314.445-2.897.965s-2.943.979-3.024 1.02c-.282.143-.431.49-.35.812.094.371.089.369 2.596 1.509 1.264.575 2.367 1.054 2.45 1.065.319.043.682-.201.791-.531a.76.76 0 0 0-.105-.633c-.112-.17-.247-.239-2.025-1.047-.479-.218-.87-.405-.87-.418s.998-.35 2.217-.751c2.307-.76 2.391-.795 2.527-1.058.034-.066.311-1.199.616-2.519s.56-2.406.567-2.412.544.801 1.193 1.793a82 82 0 0 0 1.278 1.92c.116.138.373.264.54.265.093.001 2.27-.574 4.394-1.16l.271-.075-.131.167-1.562 1.948c-.786.979-1.46 1.844-1.497 1.921-.153.321-.159.304 1.081 2.788.793 1.587 1.126 2.292 1.077 2.277l-2.071-.626c-2.206-.667-2.227-.671-2.538-.465-.412.272-.428.901-.032 1.2.169.127 5.929 1.877 6.174 1.875a.78.78 0 0 0 .605-.335c.086-.131.109-.212.11-.397.001-.228-.034-.303-1.409-3.056-.775-1.552-1.41-2.838-1.41-2.858s.97-1.246 2.157-2.725c2.347-2.927 2.292-2.847 2.197-3.224a.745.745 0 0 0-.892-.539c-.111.023-1.545.408-3.187.855l-2.985.813-1.495-2.279a323 323 0 0 0-1.607-2.435.8.8 0 0 0-.59-.308 1 1 0 0 0-.349.102M8.037 14.598a.71.71 0 0 0-.416.338c-.085.146-.142.504-.519 3.259-.35 2.567-.415 3.122-.381 3.248a.766.766 0 0 0 1.01.498c.155-.064 4.549-4.506 4.645-4.695a.715.715 0 0 0-.107-.832.724.724 0 0 0-.925-.154c-.09.054-.758.708-1.484 1.451s-1.325 1.331-1.332 1.305.097-.841.23-1.811S9 15.38 9 15.303c0-.475-.504-.844-.963-.705"
    })
  }));
});
export default SvgSpark;